<template>
    <div class="order-status-page page-details" v-if="userAuthenticated">
        <job-navigation :loading="loading" :fixedToTop="true" @closePage="closePage" title="Időtúllépés!" />

        <div class="wrapper" v-show="!loading">
            <div class="main-col" v-scroll-spy="{offset: 80, time: 500}">
                <div class="box main-data">
                    <div class="row">
                        <h1 class="">Időtúllépés!</h1><br>
                        <span>Túllépte a tranzakció elindításának lehetséges maximális idejét.</span>
                    </div>

                    <div class="row row-buttons">
                        <wbutton
                            class="btn btn-secondary"
                            type="button"
                            @click="closePage">
                            Vissza
                        </wbutton>
                    </div>
                </div>
            </div>
        </div>

        <div class="is-loading" v-show="loading"></div>

        <notification></notification>
    </div>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'

// import { stickyColHandler } from '../plugins/helpers.js'
import {MdIcon} from 'vue-material/dist/components'
import VTooltip from 'v-tooltip'
import Scrollspy from 'vue2-scrollspy'

import JobNavigation from '../components/navigations/JobNavigation.vue'
import Notification from '../components/Notification.vue'

Vue.use(MdIcon)
Vue.use(VTooltip)
Vue.use(Scrollspy)

export default {
    name: 'OrderPaymentTimeout',

    data() {
        return {
            loading: false,
        }
    },

    mounted() {
        this.$store.dispatch('FETCH_CURRENT_USER').then(() => {
            window.scrollTo(0, 0);
        }).catch((redirect) => {
            redirect && this.$router.push({name: 'OrderList'})
        })
    },

    methods: {
        closePage() {
            this.$router.push({name: 'OrderList'})
        }
    },

    computed: {
        ...mapGetters(['orderStatus', 'orderDetails', 'userHasObjects', 'userAuthenticated'])
    },

    components: {
        JobNavigation, Notification
    }
}
</script>

<style lang="scss">
@import '../assets/sass/ui/tooltip.scss';
</style>

<style lang="scss" scoped>
@import '../assets/sass/toolkit.scss';
@import '../assets/sass/layout/page-details.scss';
@import '../assets/sass/ui/input.scss';
@import '../assets/sass/ui/button.scss';
@import '../assets/sass/ui/box.scss';
@import '../assets/sass/ui/table.scss';
@import '../assets/sass/ui/navbar.scss';
@import '../assets/sass/ui/loading.scss';

.order-status-page {
    background: $color-gray-bg-1;
    overflow: hidden;
    padding-top: 60px;
    padding-bottom: 100px;

    .box {
        padding: 0;
    }

    .table {
        width: 100%;
    }

    .row {
        padding: 30px 40px 30px 40px;
    }

    .label {
        font-size: 10px;
        font-weight: bold;
        text-transform: uppercase;
        color: $color-gray-4;
        display: block;
        margin-bottom: 10px;
    }

    .main-data {
        margin-top: 32px;

        .row-progress {
            background: $color-gray-bg-1;
            border-bottom: 1px solid $color-gray-border;
        }

        .row-notify {
            background: rgba(255, 255, 0, 0.2);
            border-bottom: 1px solid $color-gray-border;
            height: 22px;
            line-height: 22px;
            font-size: 13px;
            color: $color-gray-2;
            text-align: center;
            font-weight: bold;
            padding: 0;
            margin: 0;
            text-transform: uppercase;
        }

        .row-buttons {
            display: flex;
            align-items: flex-start;
            border-bottom: 1px solid $color-gray-border;
            padding-top: 20px;
            padding-bottom: 20px;

            @media only screen and (max-width: 600px) {
                flex-direction: column;
                align-items: flex-start;
            }

            button {
                height: 40px;
            }

            .button-details {
                font-size: 14px;
                margin-left: 22px;

                i {
                    position: relative;
                    top: 2px;
                    font-size: 17px !important;
                }
            }

            .col-edit {
                display: flex;
                flex-direction: column;
                margin-left: auto;
                margin-right: 0;

                @media only screen and (max-width: 600px) {
                    margin-left: 0px;
                    align-items: baseline;
                }

                button {
                    height: auto;
                    margin: 5px 0;
                    text-align: right;
                }
            }
        }

        .row-history {
            background: $color-gray-bg-1;
            padding-top: 25px;
            padding-bottom: 20px;

            .row-history-element {
                display: flex;
                font-size: 13px;
                border-bottom: 1px dashed $color-gray-border;
                padding-bottom: 15px;
                margin-bottom: 15px;

                &:last-child {
                    margin-bottom: 5px;
                    border: 0;
                    padding: 0;
                }

                .col-status {
                    width: 30%;
                    font-weight: bold;
                }

                .col-person {
                    width: 45%;

                    span {
                        display: block;
                    }
                }

                .col-date {
                    width: 25%;
                    text-align: right;
                }
            }
        }
    }

    .order-data {
        [class^="col-"] {
            width: 33.33%;
            font-weight: 500;
        }

        .row-identification {
            display: flex;
            padding-top: 20px;
            padding-bottom: 20px;
            border-bottom: 1px solid $color-gray-border;

            .col-id,
            .col-object {
                border-right: 1px dashed $color-gray-border;
            }

            .col-object,
            .col-date {
                text-align: center;
            }

            .col-object {
                .btn {
                    display: inline-block;
                    font-weight: bold;
                    font-size: 16px;
                    line-height: 1;
                    margin: 3px 0;

                    i {
                        font-size: 14px !important;
                        margin-left: -3px;
                    }
                }
            }
        }

        .row-customer {
            display: flex;
            align-items: center;
            padding-top: 20px;
            padding-bottom: 20px;

            .col-name {
                font-size: 14px;

                .customer-number {
                    display: inline-block;
                    font-family: $font-primary;
                    margin-top: 5px;
                }
            }

            .col-phone,
            .col-email {
                font-size: 15px;
                font-family: $font-primary;
                text-align: center;

                .btn {
                    font-size: 15px;
                }
            }
        }
    }

    .shipping-data {
        [class^="col-"] {
            width: 50%;
            font-weight: 500;
        }

        .row {
            display: flex;
            border-bottom: 1px solid $color-gray-border;

            .col-time {
                padding-left: 15%;
            }

            .col-address,
            .col-recipient {
                font-size: 15px;

                span:last-child {
                    display: block;
                    font-family: $font-primary;
                    margin-top: 5px;
                    line-height: 1.2;
                }
            }

            .col-address {
                border-right: 1px dashed $color-gray-border;
                padding-right: 15px;
            }

            .col-recipient {
                padding-left: 15%;
            }

            .col-amount {
                padding-left: 15%;
                font-family: $font-primary;

                span {
                    font-weight: bold;
                }
            }

            .col-comment {
                width: 100%;
                font-family: $font-primary;
                font-size: 15px;
                line-height: 1.4;
            }
        }

    }

    .text-info-discounts {
        margin-bottom: 30px;
        font-size: 15px;
    }

    .discounts-data {
        margin-bottom: 50px;

        th,
        td {
            &:nth-child(1) {
                width: 75%;
            }

            &:nth-child(2) {
                width: 25%;
            }
        }

        td {
            &:nth-child(2) {
                font-weight: bold;
            }
        }
    }

    .products-data {
        margin-bottom: 20px;

        th,
        td {
            line-height: 20px;

            strong {
                font-weight: bold;
            }

            &:nth-child(1) {
                width: 50%;
            }

            &:nth-child(2) {
                width: 25%;
            }

            &.sub-discounts {
                font-size: 13px;
            }
        }
    }

    .btn-collapse-products {
        text-decoration: none;
        margin-left: 18px;

        span {
            text-decoration: underline;
            font-size: 14px;
        }

        i {
            font-size: 20px !important;
        }
    }
}
</style>
